import RestService from "./rest.service";

class competencyType {
  getListCompetencyType(cycle_id) {
    return new Promise((fnResolve, fnReject) => {
      if (cycle_id !== undefined && cycle_id !== null && cycle_id !== "") {
        RestService.gets(`app/admin/kpi/competency/type?cycle_id=${cycle_id}`).then(
          (response) => {
            fnResolve(response);
          },
          (response) => {
            fnReject(response);
          }
        );
      } else {
        RestService.gets(`app/admin/kpi/competency/type`).then(
          (response) => {
            fnResolve(response);
          },
          (response) => {
            fnReject(response);
          }
        );
      }
    });
  }

  createCompetencyType(data) {
    return new Promise((fnResolve, fnReject) => {
      RestService.posts(`app/admin/kpi/competency/type/add`, data).then(
        (response) => {
          fnResolve(response);
        },
        (response) => {
          fnReject(response);
        }
      );
    });
  }

  getEditCompetencyType(serial) {
    return new Promise((fnResolve, fnReject) => {
      RestService.gets(`app/admin/kpi/competency/type/${serial}`).then(
        (response) => {
          fnResolve(response);
        },
        (response) => {
          fnReject(response);
        }
      );
    });
  }

  editCompetencyType(serial, data) {
    return new Promise((fnResolve, fnReject) => {
      RestService.put(`app/admin/kpi/competency/type/${serial}/edit`, data).then(
        (response) => {
          fnResolve(response);
        },
        (response) => {
          fnReject(response);
        }
      );
    });
  }

  deleteCompetencyType(id) {
    return new Promise((fnResolve, fnReject) => {
      RestService.delete(`app/admin/kpi/competency/type/${id}/delete`).then(
        (response) => {
          fnResolve(response);
        },
        (response) => {
          fnReject(response);
        }
      );
    });
  }

  updateCompetencyType(data, cycle_id) {
    return new Promise((fnResolve, fnReject) => {
      RestService.posts(`app/admin/kpi/competency/type/seq`, data).then(
        (response) => {
          fnResolve(response);
        },
        (response) => {
          fnReject(response);
        }
      );
    });
  }
}

export default new competencyType();
